module.exports = __webpack_public_path__ + "media/kuala lumpur/kl_towers_big2-a3b01488.jpg";